module.exports = __webpack_public_path__ + "img/004-solar-panel.37480c64.svg";